export const FORM_METHOD_POST = "post";
export const FORM_METHOD_GET = "get";

export const FORM_METHODS = [FORM_METHOD_POST, FORM_METHOD_GET] as const;

export const ENCTYPE_FORM_URL_ENCODED = "application/x-www-form-urlencoded";
export const ENCTYPE_FORM_FILE = "multipart/form-data";
export const ENCTYPE_TEXT = "text/plain";

export const ENCTYPES = [ENCTYPE_FORM_URL_ENCODED, ENCTYPE_FORM_FILE, ENCTYPE_TEXT] as const;

export const GOOGLESCORE00 = "0.0";
export const GOOGLESCORE01 = "0.1";
export const GOOGLESCORE02 = "0.2";
export const GOOGLESCORE03 = "0.3";
export const GOOGLESCORE04 = "0.4";
export const GOOGLESCORE05 = "0.5";
export const GOOGLESCORE06 = "0.6";
export const GOOGLESCORE07 = "0.7";
export const GOOGLESCORE08 = "0.8";
export const GOOGLESCORE09 = "0.9";
export const GOOGLESCORE10 = "1.0";

export const GOOGLESCORES = [
  GOOGLESCORE00,
  GOOGLESCORE01,
  GOOGLESCORE02,
  GOOGLESCORE03,
  GOOGLESCORE04,
  GOOGLESCORE05,
  GOOGLESCORE06,
  GOOGLESCORE07,
  GOOGLESCORE08,
  GOOGLESCORE09,
  GOOGLESCORE10
] as const;
